import script from "./kyc-option-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./kyc-option-dialog.vue?vue&type=script&setup=true&lang=js"

import "./kyc-option-dialog.vue?vue&type=style&index=0&id=c9aaaefa&lang=scss&rel=stylesheet%2Fscss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/WEB-samp-webapp-HK/common/temp/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9aaaefa"]])

export default __exports__